<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> Policy List
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Registed Date
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> Last Modify
                <b-button size="sm" variant="info" @click="set_sd('', 'updated_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'updated_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'updated_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'updated_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'updated_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'updated_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_description">Description</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_description" v-model="so.opt['description']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <b-row>
        <b-col sm="6">
          <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
            Show Count
            <select v-model="so.perPage" @change="refresh">
              <option disabled value="15">Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-input-group-text size="sm" variant="outline-secondary">Description</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="group" slot-scope="row">{{row.item.group.groupname}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | sdate}}</template>
        <template slot="count" slot-scope="row">
          {{row.item.count | number}}
        </template>
        <template slot="description" slot-scope="row" v-if="row.item.policy">{{row.item.description  || '-'}}</template>
        <template slot="policy" slot-scope="row" v-if="row.item.policy">{{row.item.policy.limit}}</template>
        <template slot="updated_at" slot-scope="row">{{row.item.updated_at | datetime}}</template>
        <template slot="func" slot-scope="row">
          <b-btn v-if="use_view == false" @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
          <b-btn v-else @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next" />
        </b-col>
        <!-- <b-col class="md-4" v-if="use_view != false">
          <div class="pull-right">
            <b-button size="sm" :limit="10" variant="success" @click="$router.push({ name: 'wmds_policy', params: { id : 'add' } })"> New registration </b-button>
          </div>
        </b-col> -->
      </b-row>
    </b-card>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import custom from '@/custom';
import { Api } from '@/service';
import codes from '@/codes';
// import { Switch as cSwitch } from '@coreui/vue';

export default {
  props: ['item', 'use_view'],
  components: { DatePicker },
  data: () => { return { codes, so : Object.assign({}, codes.DEFAULT_OPT, { sk : 'description' }), custom } },
  computed: {
    fields : function() {return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'group', label: 'Group', sortable: false },
        { key: 'created_at', label: 'Registed_at', sortable: false },
        { key: 'count', label: 'Using Site', sortable: false },
        { key: 'description', label: 'Description', sortable: false },
        { key: 'policy', label: 'Max Page', sortable: false },
        { key: 'updated_at', label: 'Last Modify', sortable: false },
        { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['updated_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { sk : 'description', sv : '' }); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
        let so = {
          target : 'wmds.policy', cmd : 'list',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.group) { so.body.and.push({ name : 'group_id', value : this.group.id, op : '='}) }
        if(this.so.sv && this.so.sk) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'updated_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'updated_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    detail: function(item) { this.use_view != false ? this.$router.push(`/wmds/policy/${item.id}`) : this.$emit('selected', item) },
  },
  created: function() { console.log('pattern.vue', 'created'); },
  destroyed: function() { console.log('pattern.vue', 'destroyed'); },
  mounted: function() { console.log('pattern.vue', 'mounted'); },
}
</script>
